import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const categories = [
  { label: "Chaussures en vue", to: "/products/shoes" },
  { label: "Sacs a decouvrir", to: "/products/bags" },
  { label: "Nouveautes du moment", to: "/products/news" },
];

const trustPoints = [
  "De belles pieces choisies avec soin",
  "Commande simple par WhatsApp",
  "Livraison soignee et service attentif",
];

export default function TopFilterSection() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const handleSearchSubmit = () => {
    const trimmed = search.trim();
    if (!trimmed) return;
    navigate(`/products?search=${encodeURIComponent(trimmed)}`);
  };

  return (
    <section className="px-4 pb-8 pt-36 md:px-8 lg:px-10 lg:pt-40">
      <div className="mx-auto grid max-w-7xl gap-6 lg:grid-cols-[1.15fr_1.85fr]">
        <div className="surface-panel rounded-[30px] p-6 md:p-8">
          <p className="brand-eyebrow">Boutique en ligne</p>
          <h2 className="brand-display mt-4 text-3xl font-bold text-[#201410] md:text-5xl">
            De belles pieces pour sublimer chaque look.
          </h2>
          <p className="mt-5 max-w-xl text-sm leading-7 text-[#6f594d] md:text-base">
            Decouvrez une selection de sacs et de chaussures pensee pour faire
            plaisir, attirer le regard et donner envie de commander.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            {categories.map((category) => (
              <Link
                key={category.to}
                to={category.to}
                className="rounded-full border border-[rgba(62,35,24,0.1)] bg-white/75 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.26em] text-[#573e34] transition hover:border-[rgba(110,45,22,0.22)] hover:bg-[#fff5ec]"
              >
                {category.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="surface-panel rounded-[30px] p-6 md:p-8">
          <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
            <div>
              <p className="brand-eyebrow">Recherche</p>
              <h3 className="brand-display mt-3 text-2xl font-bold text-[#201410] md:text-[2.4rem]">
                Trouvez votre prochain coup de coeur.
              </h3>
            </div>
            <p className="max-w-sm text-sm leading-7 text-[#80695d]">
              Recherchez un modele, une couleur ou un style en quelques
              secondes et trouvez la piece qu’il vous faut.
            </p>
          </div>

          <div className="mt-8 rounded-[26px] bg-[linear-gradient(135deg,rgba(255,250,244,0.98),rgba(244,224,205,0.88))] p-3 shadow-[0_20px_40px_rgba(67,38,25,0.08)]">
            <div className="flex flex-col gap-3 rounded-[20px] bg-white/70 p-3 md:flex-row md:items-center">
              <div className="flex flex-1 items-center gap-3 rounded-[18px] bg-[#fffaf4] px-4 py-3">
                <span className="text-lg text-[#7a4328]">⌕</span>
                <input
                  type="text"
                  placeholder="Rechercher un sac, une chaussure, une nouveaute"
                  className="w-full border-0 bg-transparent text-sm text-[#261712] outline-none ring-0 focus:border-0 focus:outline-none focus:ring-0 placeholder:text-[#9f8576]"
                  value={search}
                  onChange={(event) => setSearch(event.target.value)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      handleSearchSubmit();
                    }
                  }}
                />
              </div>

              <button
                type="button"
                onClick={handleSearchSubmit}
                className="cta-primary rounded-[18px] px-6 py-4 text-xs font-semibold uppercase tracking-[0.3em] transition"
              >
                Chercher
              </button>
            </div>
          </div>

          <div className="mt-6 grid gap-3 md:grid-cols-3">
            {trustPoints.map((point) => (
              <div
                key={point}
                className="rounded-[22px] border border-[rgba(62,35,24,0.08)] bg-white/62 px-4 py-4 text-xs font-semibold uppercase leading-6 tracking-[0.2em] text-[#5e463b]"
              >
                {point}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
